import { render, staticRenderFns } from "./important_message_bar.vue?vue&type=template&id=40a78808&scoped=true&"
import script from "./important_message_bar.vue?vue&type=script&lang=js&"
export * from "./important_message_bar.vue?vue&type=script&lang=js&"
import style0 from "./important_message_bar.vue?vue&type=style&index=0&id=40a78808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a78808",
  null
  
)

export default component.exports